import React from "react"
import '../styles/about.css'
export default function AboutMe(){
    return(
        <div className="about">
            <div className="about-left">
                <h1 className="aboutme-header">About Me</h1>
                <p className="aboutme_para">
I am an undergraduate student pursuing <span className="aboutme-span">Computer Science
    </span> at VIT Pune. I am a passionate <span className="aboutme-span"> Web Developer
        </span> who specializes in creating clean and responsive websites.With expertise in MongoDB, Express.JS, React.JS, and Node.JS
         as the primary tech-stack,I strive to build user-friendly websites that enhance the overall user experience.
I also have a keen interest in writing <span className="aboutme-span"> blogs
    </span> and sharing my knowledge through <span className="aboutme-span"> research papers
        </span> . I enjoy exploring various topics related to technology and sharing my insights with others.
<br />
<br />
Another area of interest for me is the field of 
<span className="aboutme-span"> artificial intelligence</span> . I am fascinated by the potential of AI tools to streamline processes and enhance user interactions. I have experience developing chatbots, text summarizers, and image processors using the Python programming language.
<br />
<br />
Currently, I am focused on developing websites that are not only visually appealing but also easy to navigate and provide features that improve the overall user experience. I believe that a well-designed website can make a significant impact on how users interact with digital platforms.
<br />
<br />
<span className="aboutme-span">Open to Internships</span>


                </p>
            </div>
                <div className="about-photo">
                    
                </div>
            </div>
        
    )
}